export default __webpack_public_path__ + "static/media/site.9b239dd5.svg";